import script from "./ResultadosGallery.vue?vue&type=script&setup=true&lang=js"
export * from "./ResultadosGallery.vue?vue&type=script&setup=true&lang=js"

import "./ResultadosGallery.vue?vue&type=style&index=0&id=bbb4233c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bbb4233c"]])

export default __exports__